module.exports = __webpack_public_path__ + "static/Selection_005-b7a3346b2337b65e15de28b56e5d773e.jpeg";